import { render, staticRenderFns } from "./ChatLogItemConteudo.vue?vue&type=template&id=c9a0ab0c&"
import script from "./ChatLogItemConteudo.vue?vue&type=script&lang=js&"
export * from "./ChatLogItemConteudo.vue?vue&type=script&lang=js&"
import style0 from "./ChatLogItemConteudo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports